export default function getEnv(name: string): string | string[] {
  const result: string = (window as any)?.config?.[name] || import.meta.env[name]
  return result
}
